import { render, staticRenderFns } from "./AverageProjectDaysBreakdown.vue?vue&type=template&id=3e828123&scoped=true"
import script from "./AverageProjectDaysBreakdown.vue?vue&type=script&lang=js"
export * from "./AverageProjectDaysBreakdown.vue?vue&type=script&lang=js"
import style0 from "./AverageProjectDaysBreakdown.vue?vue&type=style&index=0&id=3e828123&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e828123",
  null
  
)

export default component.exports